import { render, staticRenderFns } from "./confirm-sharing.html?vue&type=template&id=11be95c1&scoped=true&external"
import script from "./confirm-sharing.js?vue&type=script&lang=js&external"
export * from "./confirm-sharing.js?vue&type=script&lang=js&external"
import style0 from "./confirm-sharing.scss?vue&type=style&index=0&id=11be95c1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be95c1",
  null
  
)

export default component.exports